export default function Navbar() {
    return(
                    <nav className="navbar navbar-expand-lg navbar-white bg-white">

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="nav navbar-nav ms-auto">

                    </ul>
                </div>
            </nav>
    )
}